import UserAssigment from './UserAssigment';
export default UserAssigment;